import React, { FC, PropsWithChildren, useState } from 'react';

export interface IsNavigatingContextValue {
  isNavigating: boolean;
  setIsNavigating: () => void;
}

export const IsNavigatingContext =
  React.createContext<IsNavigatingContextValue | null>(null);

export function useIsNavigating() {
  const context = React.useContext(IsNavigatingContext);
  if (!context) {
    throw new Error(
      `useIsNavigating must be used within a IsNavigatingProvider`
    );
  }
  return context;
}

export const IsNavigatingProvider: FC<PropsWithChildren> = (props) => {
  const [isNavigating, setIsNavigating] = useState(false);
  const contextValue = {
    isNavigating,
    setIsNavigating: () => {
      if (isNavigating === false) {
        setIsNavigating(true);
      }
    },
  };
  return <IsNavigatingContext.Provider value={contextValue} {...props} />;
};

export const withIsNavigating = <P extends object>(
  Component: React.FC<P & { navigating: any }>
) => {
  const WrappedComponent: React.FC<P> = (props) => {
    const navigating = useIsNavigating();
    return <Component {...props} navigating={navigating} />;
  };
  return WrappedComponent;
};
